import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { filter, map, Observable } from 'rxjs';
import { UserRole } from '../models/auth.models';
import { AuthStore } from '../../auth/auth.store';
import { environment } from '../../../environments/environment.prod';

export const roleGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<UrlTree | true> => {
    // console.log('\x1b[35m' + `[roleGuard called] url: ${state.url}` + '\x1b[0m');

    const authStore = inject(AuthStore);
    const router = inject(Router);

    return authStore.role$.pipe(
      filter((role: undefined | UserRole | null): role is UserRole => !!role),
      map((role: UserRole): true | UrlTree => {
        const goesToProperRole: boolean = state.url.startsWith(`/${role}`);

        if (goesToProperRole) {
          return true;
        } else {
          if (!environment.production) console.warn(`User with role ${role} tried to access ${state.url}`);
          return router.createUrlTree([`/${role}`]);
        }
      })
    );
  }
;
